module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_green.397073d8.svg";